import React from 'react'
import PropTypes from 'prop-types';

export const GifGridItem = ( { title, url } ) => {

    return (
        <div className='card animate__fadeIn animate__delay-2s'>
            <img src={ url } alt={ title } />
            <p className='elipsis-one-line'>{ title }</p>
        </div>
    )
}

GifGridItem.propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
}